import {
  Input as NextUINumberInput,
  InputProps as NextUINumberInputProps,
} from "@heroui/react";
import { getInputClassNames } from "../../utils/styles";

type Color = Extract<NextUINumberInputProps["color"], "default">;
type LabelPlacement = Extract<
  NextUINumberInputProps["labelPlacement"],
  "outside"
>;
type Variant = Extract<NextUINumberInputProps["variant"], "bordered">;

export type NumberInputProps = Omit<
  NextUINumberInputProps,
  "color" | "labelPlacement" | "variant"
> & {
  color?: Color;
  labelPlacement?: LabelPlacement;
  variant?: Variant;
  ref?: React.Ref<HTMLInputElement>;
};

export function NumberInput({ ref, ...props }: NumberInputProps) {
  return (
    <NextUINumberInput
      ref={ref}
      {...props}
      classNames={getInputClassNames(props.size)}
      color="default"
      data-testid={props.name}
      labelPlacement="outside"
      type="number"
      variant="bordered"
    />
  );
}

NumberInput.displayName = "RecareUI.NumberInput";
